 import React, {useEffect} from "react";
 import { Redirect, Switch, Route } from "react-router-dom";
 import { KTCookie } from "../_metronic/_assets/js/components/cookie";
 import { Layout, OnBoardLayout } from "../_metronic/layout";
 import BasePage from "./BasePage";
 import OnBoardPage from "./OnBoardPage";
 import VerifyEmail from "./modules/Auth/pages/VerifyEmail";
 import { AuthPage, Logout } from "./modules/Auth";

 export function Routes(history) {
  const isAuthorized = JSON.parse(localStorage.getItem('clientpanel')) ? true : false;
  var pathName = history.history.location.pathname;
  
  useEffect(() => {
    if(!isAuthorized) {
      KTCookie.setCookie('prevPath', pathName, {});
    }
  }, []);
  
  return (
    <Switch>
       <Route path="/verify/:code" component={VerifyEmail} />
      {pathName.indexOf("/signup") !== -1 ? (
        <OnBoardLayout>
        <OnBoardPage history={history}/>
      </OnBoardLayout>
      ) :
      <Switch>
        {!isAuthorized ? (
          /*Render auth page when user at `/auth` and not authorized.*/
          <Switch>
            <Route>
              <AuthPage />
            </Route>
          </Switch>
        ) : (
          /*Otherwise redirect to root page (`/`)*/
          <Redirect from="/login" to="/" />
        )}

        {/* <Route path="/error" component={ErrorsPage} /> */}
        <Route path="/logout" component={Logout} />

        {!isAuthorized ? (
          /*Redirect to `/auth` when user is not authorized*/
          <Redirect to="/login" />
        ) : (
          <Layout history={history.history}>
            <BasePage history={history}/>
          </Layout>
        )}
      </Switch>
    }
    </Switch>
  );
}


/* import React from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import { Layout } from "../_metronic/layout";
import BasePage from "./BasePage";

export function Routes() {
  
  return (
    <Switch>
      <Layout>
        <BasePage />
      </Layout>
    </Switch>
  );
}
 */